module.exports = "/images/zink-logo-loading-animation-color.gif?2646d3e71f4cb8ea03bae813afe9810b";